import { render, staticRenderFns } from "./ComponentSuggestion.vue?vue&type=template&id=53851db2"
import script from "./ComponentSuggestion.vue?vue&type=script&lang=js"
export * from "./ComponentSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports